import { positionsOnTheGlobe } from './streamChecks/positionsOnTheGlobe'
import { timeAdvances } from './streamChecks/timeAdvances'
import { speedMatchesMovement } from './streamChecks/speedMatchesMovement'
import type { GpsStreamCheck } from './streamChecks/gpsStreamTrust'
import { lapTimeTrusted } from './lapChecks/lapTimeTrusted'
import { distanceMatchesSpeed } from './lapChecks/distanceMatchesSpeed'
import type { LapCheck } from './lapChecks/lapReliability'

export const GPS_STREAM_CHECKS: readonly GpsStreamCheck[] = [
  positionsOnTheGlobe,
  timeAdvances,
  speedMatchesMovement,
]

export const LAP_CHECKS: readonly LapCheck[] = [
  lapTimeTrusted,
  distanceMatchesSpeed,
]
